import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column",
  style: {"height":"100vh"}
}
const _hoisted_2 = {
  key: 0,
  class: "svg-header d-flex justify-center align-center text-h5 mt-6",
  style: {"flex":"1","gap":"8px"}
}
const _hoisted_3 = {
  key: 1,
  class: "svg-header d-flex justify-center text-h5 mt-6",
  style: {"flex":"1"}
}
const _hoisted_4 = { style: {"flex":"18"} }
const _hoisted_5 = { style: {"height":"100%","width":"100%"} }
const _hoisted_6 = {
  key: 2,
  class: "d-flex justify-space-around px-12 mb-4",
  style: {"flex":"1"}
}
const _hoisted_7 = {
  key: 3,
  class: "d-flex justify-space-around px-12 mb-4",
  style: {"flex":"1"}
}

import Hex from "@/components/HexUnit.vue";
import { HexGrid } from "@/types/hex";
import { watch, reactive, ref, onMounted } from "vue";
import { useApi } from "@/api/handler";
import { game } from "@/api";
import { ApiMap } from "@/api/type";
import { GameDisplay, GameUtils } from "@/utils";
import EventTip from "@/components/board/EventTip.vue";
import { eventTip } from "@/types/event";
import ConfirmDialog from "@/components/ConfirmDialog.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BoardBox',
  props: {
    data: {},
    originX: {},
    originY: {},
    radius: {},
    rewardMode: {}
  },
  emits: ["update", "rewardConfirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const et = reactive(new eventTip());
const emits = __emit;
const selectingTeam = ref<number>(0);
const actionLeft = ref<number>(0);
const tileSelected = ref<Array<number>>([]);
const GameStatus = ref<ApiMap["/game/status/:id"]["resp"]>(props.data);
const selectedNumber = ref<number>(3);

const goldenCenterOccupy = ref<{ b: boolean; id: number }>({ b: false, id: 0 });
const blindBoxOccupy = ref<{ b: boolean; ids: Array<number> }>({
  b: false,
  ids: [],
});
const chanceLandOccupy = ref<{ b: boolean; id: number; s: boolean }>({
  b: false,
  id: 0,
  s: false,
});
const showDialog = ref<boolean>(false);

let tileSets = reactive<ApiMap["/game/occupyStatus/:gameId"]["resp"]>({
  totalTiles: 0,
  blackSwampTiles: [],
  blindBoxTiles: [],
  fortressTiles: [],
  goldCenterTiles: [],
  opportunityTiles: [],
  teams: [],
});

const rewardTileSelected = ref<number[]>([])

function onHexClick(id: number) {
  // 奖励发放模式：点选格子直到凑满步数
  if (props.rewardMode) {
    if (rewardTileSelected.value.includes(id)) return
    if (tileSets.blackSwampTiles.includes(id)) return
    if (rewardTileSelected.value.length >= props.rewardMode.stepCount) return
    hexGrid.setColor(id, GameDisplay.teamColorTrans(props.rewardMode.teamId), props.rewardMode.teamId.toString())
    rewardTileSelected.value.push(id)
    return
  }

  if (actionLeft.value === 0) return;
  if (
    tileSets.teams
      .flat()
      .map((item) => item.occupiedTiles)
      .flat()
      .includes(id)
  )
    return;
  if (tileSelected.value.includes(id)) return;
  if (tileSets.blackSwampTiles.includes(id)) return;
  if (tileSets.goldCenterTiles.includes(id)) {
    goldenCenterOccupy.value = { b: true, id: id };
    et.showEventTip("触发黄金中心事件，步数加 5");
    actionLeft.value += 5;
  }
  if (tileSets.blindBoxTiles.slice(0, 2).includes(id)) {
    blindBoxOccupy.value.b = true;
    blindBoxOccupy.value.ids.push(id);
    et.showEventTip("触发天降领地事件，步数加 2");
    actionLeft.value += 2;
  }
  if (tileSets.blindBoxTiles[tileSets.blindBoxTiles.length - 2] === id) {
    et.showEventTip("触发图片论述事件，本回合结束时进行");
  }
  if (tileSets.blindBoxTiles[tileSets.blindBoxTiles.length - 1] === id) {
    et.showEventTip("触发五词对抗赛事件，本回合结束时进行");
  }
  if (tileSets.fortressTiles.slice(0, 2).includes(id)) {
    et.showEventTip("本回合结束将进行双音节成语比赛");
  }
  if (tileSets.fortressTiles.slice(-2).includes(id)) {
    et.showEventTip("本回合结束将进行成语抢答比赛");
  }
  if (tileSets.opportunityTiles.includes(id)) {
    chanceLandOccupy.value.b = true;
    chanceLandOccupy.value.id = id;
    showDialog.value = true;
  }
  hexGrid.setColor(
    id,
    GameDisplay.teamColorTrans(selectingTeam.value),
    selectingTeam.value.toString()
  );
  actionLeft.value -= 1;
  tileSelected.value.push(id);
}

function handleReset() {
  useTileSets();
  selectingTeam.value = 0;
  tileSelected.value = [];
  useUnselectedList();
}

function handleChanceLand(b: boolean) {
  chanceLandOccupy.value.s = b;
  if (b) {
    actionLeft.value += selectedNumber.value;
    showDialog.value = false;
  } else {
    showDialog.value = false;
  }
}

const hexGrid: HexGrid = reactive(
  new HexGrid(props.originX, props.originY, props.radius)
);

watch(
  () => [props.originX, props.originY, props.radius, tileSets],
  () => {
    hexGrid.render(
      props.originX,
      props.originY,
      props.radius,
      tileSets,
      GameStatus.value.chessRound
    );
  }
);

const useGameInit = () => {
  if (!GameStatus.value) return;
  const originSet = GameUtils.getOriginTileSet();
  useApi({
    api: game.InitGame(
      GameStatus.value.id,
      285,
      originSet.blackSwampTiles,
      GameUtils.blindBoxRandom(originSet.blindBoxTiles),
      GameUtils.fortressRandom(originSet.fortressTiles),
      originSet.goldCenterTiles,
      originSet.opportunityTiles
    ),
    onSuccess: () => {
      emits("update");
      useTileSets();
    },
    tip: "游戏初始化成功",
  });
};

const useUnselectedList = () => {
  useApi({
    api: game.UnselectedList(GameStatus.value.id),
    onSuccess: (resp) => {
      for (const item of resp.data as ApiMap["/game/unselected/:gameId"]["resp"]) {
        if (item.assignCount !== 0) {
          if (item.teamId === selectingTeam.value) return;
          selectingTeam.value = item.teamId;
          actionLeft.value = item.assignCount;
          return;
        }
      }
    },
  });
};

const useTileSets = () => {
  useApi({
    api: game.TileSets(GameStatus.value.id),
    onSuccess: (resp) => {
      tileSets = resp.data as ApiMap["/game/occupyStatus/:gameId"]["resp"];
      hexGrid.render(
        props.originX,
        props.originY,
        props.radius,
        tileSets,
        GameStatus.value.chessRound
      );
    },
  });
};

const useTileOccupy = () => {
  useApi({
    api: game.TileOccupy({
      gameId: GameStatus.value.id,
      teamId: selectingTeam.value,
      tileIds: tileSelected.value,
      triggerBlindBox: blindBoxOccupy.value.b,
      triggerGoldCenter: goldenCenterOccupy.value.b,
      blindBoxTileIds: blindBoxOccupy.value.ids,
      goldCenterTileId: goldenCenterOccupy.value.id,
      challengeSuccess: chanceLandOccupy.value.s,
      chanceLandTileId: chanceLandOccupy.value.id,
      triggerChanceLand: chanceLandOccupy.value.b,
    }),
    onSuccess: () => {
      useUnselectedList();
      useTileSets();
      tileSelected.value = [];
      emits("update");
    },
    tip: "上传成功",
  });
};

watch(
  () => props.rewardMode,
  () => {
    rewardTileSelected.value = []
    useTileSets()
  }
)

watch(
  () => props.data,
  (newVal) => {
    if (newVal.stage === 0) useGameInit();
    if (newVal.chessPhase === 2) useUnselectedList();
    GameStatus.value = newVal;
    if (GameStatus.value.stage !== 0) useTileSets();
    if (newVal.chessRound === 3 && newVal.chessPhase === 0) {
      et.showEventTip("机会宝地已在地图上出现");
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_number_input = _resolveComponent("v-number-input")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (props.rewardMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "为", -1)),
            _createElementVNode("span", {
              style: _normalizeStyle(`color: ${_unref(GameDisplay).teamColorTrans(props.rewardMode.teamId)}`)
            }, "第 " + _toDisplayString(props.rewardMode.teamId) + " 组", 5),
            _createElementVNode("span", null, "选择奖励落点，已选 " + _toDisplayString(rewardTileSelected.value.length) + " / " + _toDisplayString(props.rewardMode.stepCount) + " 格", 1)
          ]))
        : (GameStatus.value.chessPhase === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[7] || (_cache[7] = _createTextVNode(" 当前为 ")),
              _createElementVNode("div", {
                class: "mx-2",
                style: _normalizeStyle(`color: ${_unref(GameDisplay).teamColorTrans(selectingTeam.value)}`)
              }, " 第 " + _toDisplayString(selectingTeam.value) + " 组 ", 5),
              _createTextVNode(" 的回合，还剩余 " + _toDisplayString(actionLeft.value) + " 步 ", 1)
            ]))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock("svg", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hexGrid.hexArray, (item, index) => {
            return (_openBlock(), _createBlock(Hex, {
              key: index,
              x: item.x,
              y: item.y,
              radius: item.radius,
              onOnHexClick: onHexClick,
              id: index,
              mode: item.mode,
              fill: item.fill,
              text: item.text
            }, null, 8, ["x", "y", "radius", "id", "mode", "fill", "text"]))
          }), 128))
        ]))
      ]),
      (props.rewardMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_v_btn, {
              width: "200",
              class: "font-weight-bold",
              color: "red-lighten-1",
              onClick: _cache[0] || (_cache[0] = () => { rewardTileSelected.value = []; useTileSets() })
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("重置")
              ])),
              _: 1,
              __: [8]
            }),
            _createVNode(_component_v_btn, {
              width: "200",
              class: "font-weight-bold",
              color: "primary",
              disabled: rewardTileSelected.value.length !== props.rewardMode.stepCount,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('rewardConfirm', { rewardId: props.rewardMode.rewardId, tileIds: rewardTileSelected.value })))
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode(" 确认发放 ")
              ])),
              _: 1,
              __: [9]
            }, 8, ["disabled"])
          ]))
        : (GameStatus.value.chessPhase === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_v_btn, {
                width: "200",
                class: "font-weight-bold",
                color: "red-lighten-1",
                onClick: handleReset
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("重置")
                ])),
                _: 1,
                __: [10]
              }),
              _createVNode(_component_v_btn, {
                width: "200",
                class: "font-weight-bold",
                color: "primary",
                onClick: useTileOccupy
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("保存")
                ])),
                _: 1,
                __: [11]
              })
            ]))
          : _createCommentVNode("", true)
    ]),
    (et.show)
      ? (_openBlock(), _createBlock(EventTip, {
          key: 0,
          title: et.title,
          duration: et.time
        }, null, 8, ["title", "duration"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showDialog).value = $event)),
      width: "auto"
    }, {
      default: _withCtx(() => [
        _createVNode(ConfirmDialog, {
          title: "触发单组挑战任务",
          text: "请老师决定该组增加步数",
          onConfirm: _cache[3] || (_cache[3] = 
        () => {
          handleChanceLand(true);
        }
      ),
          onCancel: _cache[4] || (_cache[4] = 
        () => {
          handleChanceLand(false);
        }
      )
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_number_input, {
              modelValue: selectedNumber.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedNumber).value = $event)),
              reverse: false,
              controlVariant: "default",
              label: "",
              hideInput: false,
              inset: false,
              variant: "outlined",
              density: "compact",
              min: 0,
              max: 3
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})